"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var i18next_1 = __importDefault(require("i18next"));
var date_fns_tz_1 = require("date-fns-tz");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        copyright: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        copyrightText: {
            fontSize: '0.75rem',
        },
        mobileFooter: (_a = {
                display: 'none'
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'block',
            },
            _a),
    });
});
var CopyrightWidget = function (_a) {
    var className = _a.className;
    var classes = useStyles();
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)(className, classes.copyright) },
        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.copyrightText },
            "\u00A9 ",
            (0, date_fns_tz_1.format)(Date.now(), 'yyyy'),
            " ",
            i18next_1.default.t('general.copyright'),
            ",",
            react_1.default.createElement("br", { className: classes.mobileFooter }),
            ' ',
            i18next_1.default.t('general.copyrightTag'))));
};
exports.default = CopyrightWidget;
